import React from 'react';
// import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="flex flex-col 2xl:w-[1480px] max-xl:w-[1280px] lg:w-[1080px] max-md:w-full mx-auto max-sm:w-full h-full max-md:px-[10px]">
        <div className='flex max-md:flex-col w-full md:justify-between md:px-2 my-4'>
          <div className='max-md:my-1'>Copyright © 2025 Thirtify LLC. All rights reserved.</div>
          <div className='hover:text-rose-900 cursor-pointer'>
            <a href={`/privacy-policy`}>Privacy Policy</a>
          </div>
          <div className='hover:text-rose-900 cursor-pointer max-md:mb-1'>
            <a href={`/terms-and-condition`}>Terms and conditions</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;